module.exports = __webpack_public_path__ + "static/img/reward_icon.e4990924.png";